// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIcon_root__Mt58A","content":"TextWithIcon_content__be1SB","cardTitle":"TextWithIcon_cardTitle__OxpEY","iconWrap":"TextWithIcon_iconWrap__3EZER"};